// extracted by mini-css-extract-plugin
module.exports = {"custom":"Home_custom__28TVZ"};